


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ServingNutritionDto, ServingNutritionFactDto } from '@/api';
import { TranslateResult } from 'vue-i18n';

@Component({
    components: {},
  },
)
export default class NutritionRow extends Vue {
  @Prop({required: true})
  public nutritionInformations!: ServingNutritionDto[];

  @Prop({required: true})
  public nutritionFactType: any;

  public nutritionFactLabel(key: string): TranslateResult {
    return this.$t(
      'message.detail.nutrition.labels.' + key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
    );
  }

  public hasNutritionFact(nutritionFactKey: string) {
    return !!this.nutritionInformations?.find(
      (servingNutritionDto) => !!this.nutritionFactByNutritionKey(servingNutritionDto, nutritionFactKey),
    );
  }

  public hasNutritionComponent(nutritionFactKey: string, nutritionComponentKey: string) {
    return !!this.nutritionInformations?.find(
      (servingNutritionDto) => !!this.nutritionComponentInNutritionFact(
        servingNutritionDto, nutritionFactKey, nutritionComponentKey,
      ),
    );
  }

  public nutritionFactByNutritionKey(dto: ServingNutritionDto, key: string): ServingNutritionFactDto | undefined {
    return dto.facts.find((fact) => fact.typeKey === key);
  }

  public nutritionComponentInNutritionFact(
    servingNutritionDto: ServingNutritionDto, factKey: string, componentKey: string,
  ): ServingNutritionFactDto | undefined {
    return this.nutritionFactByNutritionKey(servingNutritionDto, factKey)?.components
      ?.find((component) => component.typeKey === componentKey);
  }

  public valueStringByNutritionKey(servingNutritionDto: ServingNutritionDto, key: string): string | undefined {
    return this.nutritionFactByNutritionKey(servingNutritionDto, key)?.value;
  }

  public nutritionComponentValueStringInNutritionFact(
    servingNutritionDto: ServingNutritionDto, factKey: string, componentKey: string,
  ): string | undefined {
    return this.nutritionComponentInNutritionFact(servingNutritionDto, factKey, componentKey)?.value;
  }

  public intakeStringByNutritionKey(servingNutritionDto: ServingNutritionDto, key: string): string | undefined {
    return this.nutritionFactByNutritionKey(servingNutritionDto, key)?.intakePercent;
  }

  public nutritionComponentIntakeStringInNutritionFact(
    servingNutritionDto: ServingNutritionDto, factKey: string, componentKey: string,
  ): string | undefined {
    return this.nutritionComponentInNutritionFact(servingNutritionDto, factKey, componentKey)?.intakePercent;
  }
}
